import { InstrumentTypes } from '../Instruments/InstrumentTypes';
import { CurrencyUtils } from '../Asset/CurrencyUtils';
import { MathUtils } from '../MathUtils';
import { PriceFormatter } from '../Instruments/PriceFormatter';
export class VolumeLimitsHelper {
    getInstrumentTypes(account) {
        const instrumentTypes = [];
        const volumeLimits = account.VolumeLimits;
        for (let i = 0; i < volumeLimits.length; i++) {
            instrumentTypes.push(volumeLimits[i].instrumentTypeId);
        }
        return instrumentTypes;
    }
    getLimitValues(account, assetBalance, instrumentType) {
        let currentValue = 0;
        let limitValue = 0;
        const currentVolumeLimit = assetBalance.getAssetInstrumentVolumeLimit(instrumentType);
        if (!isNullOrUndefined(currentVolumeLimit)) {
            currentValue = currentVolumeLimit.currentVolumeLimit;
        }
        const volumeLimits = account.VolumeLimits;
        for (let i = 0; i < volumeLimits.length; i++) {
            if (volumeLimits[i].instrumentTypeId === instrumentType) {
                limitValue = volumeLimits[i].limit;
                break;
            }
        }
        return { currentValue, limitValue };
    }
    getLimitValuesStr(account, assetBalance, instrumentType) {
        let currentValueStr = '';
        let limitValueStr = '';
        const limits = this.getLimitValues(account, assetBalance, instrumentType);
        if (limits.limitValue <= 0)
            return { currentValueStr, limitValueStr };
        currentValueStr = this.formatLimitValue(limits.currentValue, account, instrumentType);
        limitValueStr = this.formatLimitValue(limits.limitValue, account, instrumentType);
        return { currentValueStr, limitValueStr };
    }
    concatLimitValuesStr(currentValueStr, limitValueStr) {
        if (!isValidString(currentValueStr) && !isValidString(limitValueStr)) {
            return '';
        }
        return `${currentValueStr}/${limitValueStr}`;
    }
    getLocalizationKey(instrumentType) {
        switch (instrumentType) {
            case InstrumentTypes.ALL:
                return 'panel.accounts.VolumeLimitForALL';
            case InstrumentTypes.FOREX:
                return 'panel.accounts.VolumeLimitForFOREX';
            case InstrumentTypes.EQUITIES:
                return 'panel.accounts.VolumeLimitForEQUITIES';
            case InstrumentTypes.FUTURES:
                return 'panel.accounts.VolumeLimitForFUTURES';
            case InstrumentTypes.OPTIONS:
                return 'panel.accounts.VolumeLimitForOPTIONS';
            case InstrumentTypes.EQUITIES_CFD:
                return 'panel.accounts.VolumeLimitForEQUITIES_CFD';
            case InstrumentTypes.FORWARD:
                return 'panel.accounts.VolumeLimitForFORWARD';
            case InstrumentTypes.CFD_FUTURES:
                return 'panel.accounts.VolumeLimitForCFD_FUTURES';
            case InstrumentTypes.INDICIES:
                return 'panel.accounts.VolumeLimitForINDICIES';
            case InstrumentTypes.CRYPTO:
                return 'panel.accounts.VolumeLimitForCRYPTO';
            case InstrumentTypes.SPREADBET:
                return 'panel.accounts.VolumeLimitForSPREADBET';
            case InstrumentTypes.FIXED_INCOME:
                return 'panel.accounts.VolumeLimitForFIXED_INCOME';
            case InstrumentTypes.ETF:
                return 'panel.accounts.VolumeLimitForETF';
            case InstrumentTypes.TBILL:
                return 'panel.accounts.VolumeLimitForTBILL';
            case InstrumentTypes.SPOT:
                return 'panel.accounts.VolumeLimitForSPOT';
            case InstrumentTypes.CORPORATE:
                return 'panel.accounts.VolumeLimitForCORPORATE';
            case InstrumentTypes.FUND:
                return 'panel.accounts.VolumeLimitForFUND';
            default:
                return 'panel.accounts.VolumeLimit';
        }
    }
    getTooltipLocalizationKey(instrumentType) {
        if (instrumentType === InstrumentTypes.ALL) {
            return 'panel.accounts.VolumeLimit.All.descr';
        }
        else {
            return 'panel.accounts.VolumeLimit.descr';
        }
    }
    formatLimitValue(value, account, instrumentType) {
        const asset = this.getLimitAssetForAccount(account, instrumentType);
        if (isNullOrUndefined(asset)) {
            const prec = MathUtils.getPrecision(value);
            return PriceFormatter.formatPrice(value, prec);
        }
        else {
            const formattedPrice = asset.formatPrice(value, true);
            return CurrencyUtils.FormatWithCurrencySymbol(formattedPrice, asset.Name);
        }
    }
    getLimitAssetForAccount(account, instrumentType) {
        if (isNullOrUndefined(account)) {
            return null;
        }
        const volumeLimits = account.VolumeLimits;
        for (let i = 0; i < volumeLimits.length; i++) {
            const volumeLimit = volumeLimits[i];
            if (volumeLimit.instrumentTypeId === instrumentType) {
                if (isValidNumber(volumeLimit.limitCcyId)) {
                    let asset = account.DataCache.GetAssetById(volumeLimit.limitCcyId);
                    if (isNullOrUndefined(asset)) {
                        asset = account.assetBalanceDefault.Asset;
                    }
                    return asset;
                }
            }
        }
        return null;
    }
}
